module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Gestorbenes Erz")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich weiß nicht, was soll es bedeuten,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndaß meine Träne rinnt"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nzuweilen, wenn ferne das Läuten"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nder Glocke, der Glocke beginnt.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Die Sonne umhüllt sich mit Rosen"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund taucht ins Schilf am Ried,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Wellen, die leisen, die losen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsie flüstern ins heilige Lied.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Die Wellen, die Gräser, die Föhren,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nsie lauschen rings umher."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nDie Menschen, sie lieben und hören"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Glocke, die Glocke nicht mehr.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Es geht, ein verlassener Armer,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nihr Ton durchs öde Land:"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nEr predigt vom großen Erbarmer,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nden Gott aus dem Himmel gesandt.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Er predigt das Licht und den Frieden,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nden Christus hat gebracht,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndenn wieder gebietet hienieden"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nder grausame Krieg und die Nacht.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page30",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" Du hallende, dröhnende Klage"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nam stillen Gotteshaus;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndu Geist der vergangenen Tage,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndein Reich der Versöhnung ist aus!")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Wohl hast du zu Grabe geleitet"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nmanch müdes Menschenherz,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nnun ist auch dein Hügel bereitet,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndu armes, gestorbenes Erz.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2799bce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0015.vue
// module id = 99
// module chunks = 0